'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import { Dropdown } from '@heroui/react'
import { getHomePath, getUserDashboardPath } from '@/src/routes/routes'
import { UserProfileSVG } from '@/src/ui/AllSVG'
import { clearAllCookiesAndReload } from '@/src/utils/authCookies'

type AccountDropdownProps = {
    isHome: boolean
    scrolled: boolean
}

export default function AccountDropdown({ isHome, scrolled }: AccountDropdownProps) {
    const router = useRouter()

    const triggerClass = `flex items-center gap-0.5 hover:opacity-70 transition-opacity cursor-pointer bg-transparent border-0 p-0 ${isHome && !scrolled ? 'text-white' : 'text-black'}`

    const handleLogout = () => {
        clearAllCookiesAndReload(getHomePath())
    }

    return (
        <Dropdown>
            <Dropdown.Trigger className={triggerClass} aria-label="Account menu">
                <UserProfileSVG />
            </Dropdown.Trigger>
            <Dropdown.Popover placement="bottom start" className="min-w-44 rounded-md! overflow-hidden">
                <Dropdown.Menu>
                    <Dropdown.Item
                        textValue="Profile"
                        className="cursor-pointer"
                        onAction={() => router.push(getUserDashboardPath())}
                    >
                        Profile
                    </Dropdown.Item>
                    <Dropdown.Item
                        textValue="Logout"
                        className="cursor-pointer text-red-600 data-focused:text-red-700"
                        onAction={handleLogout}
                    >
                        Logout
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown.Popover>
        </Dropdown>
    )
}
